import { FC, useEffect } from "react";
import { createPortal } from "react-dom";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

import FacilityMapZoomControls from "./FacilityMapZoomControls";

const FacilityMapViewer: FC<{ mapImageUrl: string; onClose: () => void }> = ({
  mapImageUrl,
  onClose,
}) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return createPortal(
    <div className="fixed inset-0 z-[100] flex flex-col bg-primaryDarkBlue/95 backdrop-blur-sm">
      <div className="flex items-center justify-between px-5 py-4">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/40">
          Facility Map
        </p>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close map"
          className="flex size-10 items-center justify-center rounded-full border border-white/[0.08] bg-white/[0.04] text-white/70 transition-colors hover:bg-white/[0.08] hover:text-white"
        >
          <svg
            className="size-5"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div className="relative flex-1">
        <TransformWrapper
          initialScale={1}
          minScale={0.5}
          maxScale={8}
          centerOnInit
          doubleClick={{ mode: "zoomIn", step: 0.7 }}
          wheel={{ step: 0.15 }}
          pinch={{ step: 5 }}
        >
          <FacilityMapZoomControls />
          <TransformComponent
            wrapperStyle={{ width: "100%", height: "100%" }}
            contentStyle={{ width: "100%", height: "100%" }}
          >
            <img
              src={mapImageUrl}
              alt="Basecamp facility map"
              className="size-full object-contain"
            />
          </TransformComponent>
        </TransformWrapper>
      </div>
    </div>,
    document.body,
  );
};

export default FacilityMapViewer;
